module.exports = __webpack_public_path__ + "plus-icon-b520292b63691f44ae94626312181bd9.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/icons/plus-icon.svg
// module id = 55
// module chunks = 0